module.exports = __webpack_public_path__ + "img/p22.bded44f5.png";